import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BrandImage } from "@/components/BrandImage";
import { Reveal } from "@/components/Reveal";

const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : null;

export const ArticleCard = ({ article, i = 0 }) => (
  <Reveal delay={i * 60}>
    <Link
      to={`/technology-advice/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="card-base group h-full flex flex-col overflow-hidden !p-0"
    >
      <BrandImage
        src={article.featured_image}
        alt={article.title}
        className="w-full h-44"
        testId={`article-card-image-${article.slug}`}
      />
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-xs font-heading font-bold uppercase tracking-wide text-cts-red mb-2">
          <span>{article.category}</span>
          {article.published_at && <span className="text-cts-charcoal/50">• {formatDate(article.published_at)}</span>}
        </div>
        <h4 className="font-heading font-bold text-lg text-cts-ink mb-2">{article.title}</h4>
        {article.excerpt && <p className="text-[15px] leading-relaxed text-cts-charcoal flex-1">{article.excerpt}</p>}
        <span className="link-arrow mt-4">READ ARTICLE <ArrowRight size={15} /></span>
      </div>
    </Link>
  </Reveal>
);
